import LTR from "@brand-icons/global/package-cross/package-cross-ltr.svg";
import RTL from "@brand-icons/global/package-cross/package-cross-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageCrossIcon = iconFactory("PackageCrossIcon", LTR, RTL);
